module.exports = __webpack_public_path__ + "static/media/shop.efa424f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/shop.svg
// module id = 912
// module chunks = 0